import { Outlet, useParams } from "react-router";

export function OrdersHandler(props){
    
    let param = useParams();
    return <Outlet {...props} params={param} />
}